exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.employers[data-v-07498eff]{height:100%}div.content[data-v-07498eff]{padding-top:58px;padding-bottom:67px;background-color:#fff;min-height:100%}div.actions[data-v-07498eff]{text-align:right}", ""]);

// exports
